import React from 'react';
import StrippedBackElement from 'admin-components/utils/strippedBackElement';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { X, ChevronDown } from 'react-feather';
import { colours } from 'themes/default';

export const StyledClearButton = styled(X)`
  cursor: pointer;
  padding: 1em;
`;

export const StyledDropdownButton = styled(StrippedBackElement).attrs({
  element: 'span',
  children: <ChevronDown color={colours.Greyscale.CharcoalGrey.toString()} size={22} />
})`
  cursor: pointer;
  color: black;
  transition: transform 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  ${ifProp(
    'menuIsOpen',
    css`
      transform: rotate(180deg);
    `
  )}

  input {
    color: black;
  }
`;
